import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./ElectronicInvoicingPage.scss";
import bannerElectronicInvoicing from "../../assets/images/banner-electronic-invoicing.png";
import Copyright from "../../components/Copyright/Copyright";

const ElectronicInvoicingPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="feature-page">
      {/* Hero Section */}
      <section className="feature-hero">
        <div className="container">
          <div className="feature-hero-image">
            <img src={bannerElectronicInvoicing} alt="Electronic Invoicing" />
          </div>
        </div>
      </section>

      {/* Electronic Invoicing Information */}
      <section className="feature-info">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-details">
              <h2>Electronic invoicing</h2>
              <p>
                CashManager provides comprehensive electronic invoicing capabilities that streamline
                your billing processes and ensure compliance with international standards and local regulations.
              </p>

              <div className="feature-methods">
                <div className="feature-method">
                  <div className="method-content">
                    <h3>PEPPOL 3.0 compliance</h3>
                    <p>Full support for PEPPOL 3.0 standard, enabling seamless electronic document exchange across Europe and beyond.</p>
                  </div>
                </div>

                <div className="feature-method">
                  <div className="method-content">
                    <h3>Latvian electronic invoices (e-rēķini)</h3>
                    <p>Get ready for 2028 now - integrate with Latvian government-mandated electronic invoicing system. Deliver invoices by email or through the Latvija.lv system.</p>
                  </div>
                </div>

              </div>
            </div>

            <div className="feature-features">
              <h2>Key features</h2>

              <div className="features-list">
                <div className="feature-item">
                  <h3>Automated invoice generation</h3>
                  <p>Generate electronic invoices automatically from your existing data.</p>
                </div>

                <div className="feature-item">
                  <h3>Custom templates</h3>
                  <p>Customize your invoices with your own templates and branding.</p>
                </div>

                {/* <div className="feature-item">
                  <h3>Digital signatures</h3>
                  <p>Secure your invoices with digital signatures using Smart-ID, eParaksts, and other certified solutions.</p>
                </div> */}

                <div className="feature-item">
                  <h3>Real-time delivery</h3>
                  <p>Send invoices instantly through secure electronic channels with delivery confirmation.</p>
                </div>

                <div className="feature-item">
                  <h3>Compliance monitoring</h3>
                  <p>Automatic validation and compliance checking to ensure your invoices meet all regulatory requirements.</p>
                </div>

                <div className="feature-item">
                  <h3>Integration capabilities</h3>
                  <p>Seamless integration with your existing ERP, accounting, and business systems.</p>
                </div>

                <div className="feature-item">
                  <h3>Audit trail</h3>
                  <p>Complete audit trail of all electronic invoice transactions for compliance and record-keeping.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Supported Standards Section */}
      <section className="supported-section">
        <div className="container">
          <div className="section-header">
            <h2>Supported standards & formats</h2>
          </div>

          <div className="items-grid">

            <div className="item">
              <h3>File formats</h3>
              <ul>
                <li>PEPPOL 3.0</li>
                <li>PDF</li>
                <li>Custom formats - <Link to="/contact">Contact us</Link> for options</li>
              </ul>
            </div>

            <div className="item">
              <h3>Digital signatures</h3>
              <ul>
                <li>Smart-ID</li>
                <li>eParaksts (Latvian digital signature)</li>
                <li>Estonian and Lithuanian ID cards</li>
                <li>Other signature solutions - <Link to="/contact">Contact us</Link> for options</li>
              </ul>
            </div>

            <div className="item">
              <h3>Delivery channels</h3>
              <ul>
                <li>Email delivery</li>
                <li>Latvija.lv system</li>
                <li>Other - <Link to="/contact">Contact us</Link> for options</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Implementation Process */}
      <section className="implementation-process">
        <div className="container">
          <div className="section-header">
            <h2>Implementation process</h2>
            <p>Get started with electronic invoicing in just a few simple steps</p>
          </div>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Requirements analysis</h3>
                <p>We analyze your current invoicing processes and identify the possible solution.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>System configuration</h3>
                <p>Configure your system with the appropriate standards, formats, and digital signature solutions.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Testing & validation</h3>
                <p>Comprehensive testing with your business partners and regulatory bodies to ensure compliance.</p>
              </div>
            </div>

            <div className="process-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Go Live & training</h3>
                <p>Deploy to production with comprehensive training and ongoing support for your team.</p>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to go electronic?</h2>
            <p>Contact our team to discuss your electronic invoicing requirements and get started with modern, compliant invoicing today.</p>
            <Link to="/onboarding" className="btn btn-secondary btn-large">Get started</Link>
          </div>
        </div>
      </section>

      {/* Copyright Section */}
      <Copyright />
    </div>
  );
};

export default ElectronicInvoicingPage;
